import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    component: () => import(/* webpackChunkName: "maintenance" */ '../views/Maintenance.vue'),
  },
  {
    path: '/static/:slug',
    name: 'static',
    // component: () => import(/* webpackChunkName: "static" */ '../views/Static.vue'),
    component: () => import(/* webpackChunkName: "static" */ '../views/NotFound.vue'),
  },
  {
    path: '/category/:slug',
    name: 'submenu',
    component: () => import(/* webpackChunkName: "submenu" */ '../views/Submenu.vue'),
  },
  {
    path: '/p/:uuid',
    name: 'read',
    component: () => import(/* webpackChunkName: "read" */ '../views/Category.vue'),
  },
  {
    path: '/embed/:slug',
    name: 'embed',
    component: () => import(/* webpackChunkName: "embed" */ '../views/Embed.vue'),
  },
  {
    path: '/static/:parent/:slug',
    name: 'read',
    component: () => import(/* webpackChunkName: "read" */ '../views/Static.vue'),
  },
  {
    path: '/ahli',
    name: 'homeAhli',
    component: () => import(/* webpackChunkName: "homeAhli" */ '../views/HomeAhli.vue'),
  },
  {
    path: '/ahli/:name',
    name: 'listingAhli',
    component: () => import(/* webpackChunkName: "listingAhli" */ '../views/ListingAhli.vue'),
  },
  {
    path: '/ahli/search',
    name: 'listingAhli',
    component: () => import(/* webpackChunkName: "listingAhli" */ '../views/ListingAhli.vue'),
  },
  {
    path: '/:parent/:slug',
    name: 'read',
    component: () => import(/* webpackChunkName: "read" */ '../views/Read.vue'),
  },
  {
    path: '/:parent',
    name: 'category',
    component: () => import(/* webpackChunkName: "category" */ '../views/Category.vue'),
  },
  {
    path: '/:parent/edition/:year',
    name: 'category',
    component: () => import(/* webpackChunkName: "category" */ '../views/Category.vue'),
  },
  {
    path: '*',
    name: 'notFound',
    component: () => import(/* webpackChunkName: "notFound" */ '../views/NotFound.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const { app }: any = router;
  const r = await app.$http.get(app.$config.uri('config/item/underMaintenance'));
  const underMaintenance = r.data && r.data.status === 200 && r.data.data === 1;

  /**
   * Redirect to home if page is under maintenance
   * but maintenance mode is off
   *
   */
  if (to.path.indexOf('/maintenance') >= 0 && !underMaintenance) {
    next({ path: '/' });
    return;
  }

  /**
   * Check for maintenance mode
   * if this not maintenance page
   *
   */
  if (to.path.indexOf('/maintenance') < 0 && underMaintenance) {
    next({ path: '/maintenance' });
    return;
  }

  next();
});

export default router;
